import { put, takeLatest } from 'redux-saga/effects';
import staffActionTypes from '../types';
import { Notify } from '@flexisaf/flexibull2';
import { parentStatusFailure, parentStatusSuccess } from '../actions';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';

export function* parentStatus({ payload }) {
  try {
    const response = yield httpClient.put('/parents', payload);
    yield put(parentStatusSuccess(response.data));
    Notify(
      `Parent ${payload.active_status === 'ACTIVE' ? 'Activated' : 'Deactivated'} successfully`,
      { position: 'top-right' },
    );
  } catch (error) {
    yield put(parentStatusFailure(error?.message, payload));
    const err = handleError(error);
  }
}

export function* onParentStatusStart() {
  yield takeLatest(staffActionTypes.PARENT_STATUS_START, parentStatus);
}
